import { Avatar } from '@mui/material'
import { FC } from 'react'

interface CandidateAvatarProps {
    firstName?: string
    lastName?: string
    profileImage?: string
    /** Custom styling for the avatar */
    sx?: any
}

/**
 * CandidateAvatar Component
 *
 * Renders a circular avatar displaying either:
 * - The candidate's profile image (if available)
 * - Initials from their first and last name (fallback)
 */
const CandidateAvatar: FC<CandidateAvatarProps> = ({
    firstName,
    lastName,
    profileImage,
    sx,
}) => {
    // Generate initials from first and last name
    const initials = `${(firstName ?? '').slice(0, 1)}${(lastName ?? '').slice(0, 1)}`

    return (
        <Avatar src={profileImage} sx={sx}>
            {initials}
        </Avatar>
    )
}

export default CandidateAvatar
